import React, { useEffect } from 'react';
import {useRef} from 'react';
import axios from 'axios';

const userNote = (props) => {
  const note = useRef(null);

  const user_id = props.user_id;

  useEffect(() => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('[name=csrf-token]').content;

    axios.get('/admin/users/' + user_id + '/user_note').then((res) => { note.current.value = res.data.note });
  }, [])

  const handleClick = event => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('[name=csrf-token]').content;

    const param = { note_text: note.current.value }
    axios.put('/admin/users/' + user_id + '/update_user_note', param);
  };

  return (
    <div>
      <label htmlFor="message" style={{paddingBottom: '0.5rem'}}>Note</label>
      <textarea ref={note} id="message" onBlur={handleClick} name="message" className="area-style" maxLength="800" style={{resize: 'none', padding: '5px'}} placeholder="Notes on all communications with the user..." />
      <p className='text-xs mt-0.5' >max 800 characters </p>
    </div>
  );
};

export default userNote;
